export default function SocialMedia() {
  const socials = [
    {
      name: 'TikTok',
      icon: 'ri-tiktok-fill',
      url: 'https://www.tiktok.com/@mariomoya.ec',
      color: 'hover:bg-[#000000]'
    },
    {
      name: 'Instagram',
      icon: 'ri-instagram-fill',
      url: 'https://www.instagram.com/mariomoya.ec',
      color: 'hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#F77737]'
    },
    {
      name: 'LinkedIn',
      icon: 'ri-linkedin-fill',
      url: 'https://www.linkedin.com/in/mario-moya-carrillo-b81a68247',
      color: 'hover:bg-[#0A66C2]'
    }
  ];

  return (
    <section className="py-16 px-6 lg:px-12 bg-black border-t border-[#D4AF37]/20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
            Síguenos en <span className="text-[#D4AF37]">Redes Sociales</span>
          </h3>
          <p className="text-gray-400">
            Mantente actualizado con contenido exclusivo sobre inversiones
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {socials.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex items-center gap-3 bg-[#0A0A0A] border border-[#D4AF37]/30 rounded-xl px-8 py-4 transition-all duration-300 ${social.color} hover:border-[#D4AF37] hover:scale-105 cursor-pointer`}
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${social.icon} text-2xl text-[#D4AF37] group-hover:text-white transition-colors`}></i>
              </div>
              <span className="text-lg font-semibold text-white whitespace-nowrap">
                {social.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
